import React from 'react'
import FormActualité from '../../Components/FormActualité'

const AjouterActualite = () => {
  return <FormActualité />
}

export default AjouterActualite
